import { MdPlace } from 'react-icons/md';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';
import defaultDestinationImage from 'images/header.jpg';

export default function DestinationInfo({ xMargins = {}, marginTop = {} }) {
  return (
    <>
      <SectionLabelWithIcon
        label="Destination / Resort information"
        icon={<MdPlace />}
        style={{ ...xMargins, ...marginTop, marginBottom: '1rem' }}
        isPdf
      />
      <img
        src={defaultDestinationImage}
        alt="destination"
        style={{ width: '100%' }}
      />
      <div
        style={{
          paddingTop: '2rem',
          paddingBottom: '2rem',
          marginBottom: '3rem',
          background: '#EEEEEE',
        }}
      >
        <p style={{ ...xMargins }}>
          Vivamus egestas purus viverra vestibulum ornare. Sed sagittis massa
          tortor, nec euismod dui convallis quis. Quisque ipsum lacus, bibendum
          ut lorem nec, aliquam gravida nunc. Integer ullamcorper iaculis felis,
          ac hendrerit mauris placerat vel. Maecenas arcu massa, sollicitudin id
          nulla non, efficitur euismod lectus. Mauris luctus consequat nibh.
          Nunc convallis sit amet dolor quis volutpat. Praesent pellentesque
          pulvinar tellus, eget pretium justo molestie in. Suspendisse imperdiet
          magna ut posuere molestie. Suspendisse ullamcorper accumsan eros in
          dignissim. Aenean semper orci purus, in ultrices dolor scelerisque
          eget.
        </p>
      </div>
    </>
  );
}
